// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminCreateProfileLogsPage_wrapper__t1Hgz"};